





















































































import { Component, Vue } from 'vue-property-decorator'
import NavigationButtons from '@/components/ui/NavigationButtons.vue'
import OptionModule from '@/components/OptionModule.vue'
import CompareSlider from '@/components/ui/CompareSlider.vue'
import ToggleButton from '@/components/ui/ToggleButton.vue'
import ToggleSwitch from '@/components/ui/ToggleSwitch.vue'
import { ModuleOption, InformationCodes } from '@/data/enums'

@Component({
  components: {
    CompareSlider,
    NavigationButtons,
    OptionModule,
    ToggleButton,
    ToggleSwitch
  },
  computed: {
    dneye: {
      get (): string {
        if (this.$store.state.cart.currentItem.dneye === null) return ''
        return (this.$store.state.cart.currentItem.dneye) ? 'yes' : 'no'
      },
      set (value) {
        const booleanValue = (value === 'yes')
        this.$store.dispatch('cart/setDneye', booleanValue)
          .catch((err) => console.error(err))
      }
    }
  }
})
export default class DneyeModule extends Vue {
  private backgroundImage: string = 'module/dneye/dneye_color_background.png'
  private coverImage: string = 'module/dneye/dneye_color_cover.png'
  private informationCode: string = InformationCodes.ModuleDneye
  private optionId: number = ModuleOption.Dneye

  private get next (): string {
    // check if optician has impressionist
    const hasImpressionist = this.$store.state.data.optician.impressionist
    let path = '/glasses/impressionist'
    if (!hasImpressionist) {
      path = '/glasses/glass'
    }
    const count = this.$store.state.cart.items.length
    if (count > 1) { // skip if more then 2 items
      path = '/glasses/glass'
    }
    return path
  }

  private options: Array<{
    id: number,
    title: string,
    background: string,
    cover: string,
    thumbnail: string,
    selected: boolean
  }> = [
    {
      id: 0,
      title: 'module_dneye_color',
      background: 'module/dneye/dneye_color_background.png',
      cover: 'module/dneye/dneye_color_cover.png',
      thumbnail: 'module/dneye/dneye_color_thumbnail.png',
      selected: true
    },
    {
      id: 1,
      title: 'module_dneye_contrast',
      background: 'module/dneye/dneye_contrast_background.png',
      cover: 'module/dneye/dneye_contrast_cover.png',
      thumbnail: 'module/dneye/dneye_contrast_thumbnail.png',
      selected: false
    },
    {
      id: 2,
      title: 'module_dneye_night',
      background: 'module/dneye/dneye_night_background.png',
      cover: 'module/dneye/dneye_night_cover.png',
      thumbnail: 'module/dneye/dneye_night_thumbnail.png',
      selected: false
    },
    {
      id: 3,
      title: 'module_dneye_view',
      background: 'module/dneye/dneye_view_background.png',
      cover: 'module/dneye/dneye_view_cover.png',
      thumbnail: 'module/dneye/dneye_view_thumbnail.png',
      selected: false
    },
    {
      id: 4,
      title: 'module_dneye_night',
      background: 'module/dneye/dneye_nightvision_background.mp4',
      cover: 'module/dneye/dneye_nightvision_cover.mp4',
      thumbnail: 'module/dneye/dneye_nightvision_thumbnail.png',
      selected: false
    }
  ]

  private selectOption (index: number) {
    for (let i = 0; i < this.options.length; i++) {
      if (index === i) {
        this.options[i].selected = true
        this.backgroundImage = this.options[i].background
        this.coverImage = this.options[i].cover
      } else {
        this.options[i].selected = false
      }
    }
  }
}
